























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import VueElementLoading from "vue-element-loading";
import { MonitoringSnpApi } from "@/modules/monitoring-snp/api/MonitoringSnpApi";

interface IVillagePassportAddress {
    region: string;
    district: string;
    snp: string;
    code: string;
}

interface IVillagePassportValue {
    year: number;
    head: string;
    columnNumber: number;
    reportId: number;
    value: any;
}

interface IVillagePassportData {
    photo?: any;
    address?: IVillagePassportAddress;
    report?: IVillagePassportValue[];
}

@Component({
    name: "c-village-passport-modal",
    components: { loading: VueElementLoading },
})
export default class CVillagePassportModal extends Vue {
    private years: number[] = [];
    private showModal = false;
    private code?: number;
    private filteredYear = 2018;
    private data: IVillagePassportData = {};
    private isLoading: boolean = false;
    private form_code = "";

    private showEvent(code: number, form_code: string) {
        if (!code) {
            return;
        }
        this.code = code;
        this.loadYears();
        this.showModal = true;
        this.form_code = form_code;
    }

    private loadYears() {
        MonitoringSnpApi.get("/snp/api/v1/admin/years")
            .then((res) => {
                this.years = res?.data?.length
                    ? res.data.sort()
                    : [new Date().getFullYear()];
                this.filteredYear = this.years[0];
                this.getData();
            })
            .catch(() => {
                this.years = [new Date().getFullYear()];
                this.filteredYear = this.years[0];
                this.getData();
            });
    }

    private getData() {
        this.isLoading = true;
        const params = { year: this.filteredYear };
        MonitoringSnpApi.get(
            `/snp/api/v2/report/${this.form_code}/${this.code}`,
            params
        )
            .then(({ data }: { data: any }) => (this.data = data.data))
            .catch(() => (this.isLoading = false))
            .finally(() => (this.isLoading = false));
    }

    private downloadFile() {
        const params = { cato_code: this.code, year: this.filteredYear };
        MonitoringSnpApi.downloadFile("/snp/api/v2/report/export/doc", params);
    }

    private handleUploadFile(event: any) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        MonitoringSnpApi.post(
            `/snp/api/v1/report/photo/upload?code=${this.code}`,
            formData
        )
            .then(() => this.getData())
            .catch(() => {});
    }
}
